<script setup lang="ts">
  import { computed, ref, watch } from 'vue'

  const emit = defineEmits<{
    (e: 'clicked'): void,
  }>()

  const props = defineProps<{
    top?: boolean,
    bottom?: boolean,
    left?: boolean,
    right?: boolean,
    disabled?: boolean,
  }>()

  const center = computed(() => {
    if (props.left || props.right) {
      return false
    }

    return true
  })

  const dropdownOpen = ref(false)
  const close = () => {
    dropdownOpen.value = false
  }

  watch(dropdownOpen, () => {
    emit('clicked')
  })

  defineExpose({ close })
</script>

<template>
  <div
    v-click-outside="close"
    class="relative">
    <button
      class="relative z-10 block w-full"
      type="button"
      :disabled="disabled"
      @click="dropdownOpen = !dropdownOpen">
      <slot
        name="button"
        :dropdown-open="dropdownOpen"></slot>
    </button>

    <div
      v-show="dropdownOpen"
      class="absolute z-50 rounded-md border bg-white shadow-md"
      :class="{
        'left-0': left,
        'right-0': right,
        'inset-x-0': center,
        'top-0': top,
        'bottom-0': bottom,
      }">
      <slot></slot>
    </div>
  </div>
</template>
